import { DataProvider } from 'react-admin'
import { IksorisParkingTicketCashlessMachineDto } from '../../dto/device/ticket-machines/iksoris-parking-ticket-cashless-machine/iksoris-parking-ticket-cashless-machine.dto'

const fakeFiles: IksorisParkingTicketCashlessMachineDto[] = []

const provider = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getList: (resource, params) =>
    Promise.resolve({ data: fakeFiles, total: fakeFiles.length }),
} as DataProvider

export default provider
